import {Stack} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";
import {
    InlineInput,
    InlineLabelledField,
    localizedValue,
    patchLocalized,
    QuestionEditorProps
} from "./questionEditor.types";

function YesNoQuestionEditor(props: QuestionEditorProps) {
    const {t} = useTranslation();
    const {question, language, disabled} = props;

    return (
        <Stack direction={{xs: 'column', sm: 'row'}} gap={1.5}>
            <InlineLabelledField label={t('Yes label')}>
                <InlineInput
                    value={localizedValue(question.yesLabel, language)}
                    onChange={(value) => patchLocalized(props, 'yesLabel', value)}
                    placeholder={t('Yes')}
                    disabled={disabled}
                />
            </InlineLabelledField>

            <InlineLabelledField label={t('No label')}>
                <InlineInput
                    value={localizedValue(question.noLabel, language)}
                    onChange={(value) => patchLocalized(props, 'noLabel', value)}
                    placeholder={t('No')}
                    disabled={disabled}
                />
            </InlineLabelledField>
        </Stack>
    );
}

export default YesNoQuestionEditor;
